"use client";

import { useParams, useRouter } from "next/navigation";
import { useCallback } from "react";
import { useKeyboardShortcut } from "skedyul-ui/ui";
import {
  getNewThreadHref,
  NEW_THREAD_SHORTCUT_KEYS,
} from "@/lib/threadNavigation";

export function useNewThreadShortcut(): void {
  const router = useRouter();
  const params = useParams<{ subdomain: string }>();
  const subdomain = params.subdomain;

  const handleNewThread = useCallback(() => {
    if (!subdomain) return;
    router.push(getNewThreadHref(subdomain));
  }, [router, subdomain]);

  useKeyboardShortcut({
    id: "thread.new",
    keys: NEW_THREAD_SHORTCUT_KEYS,
    handler: handleNewThread,
    enabled: () => Boolean(subdomain),
  });
}
